/**
 * Reject Reasons — red-tinted list of Lazada rejection messages.
 * Hidden if no reject reasons. Lazada-only widget.
 */

import type { ExperienceWidgetProps } from "@/lib/views/widgets/registry";
import { getChannelConfig, parseJsonField } from "./shared";

export function LazadaRejectReasonsWidget({ section, formData }: ExperienceWidgetProps) {
  const config = getChannelConfig(section.description || "");
  if (!config.rejectReasons) return null;

  const reasons = parseJsonField<Array<string | { message?: string; reason?: string }>>(
    formData?.[config.rejectReasons],
  );

  if (!reasons || !Array.isArray(reasons) || reasons.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide pl-4 mb-2">
        Issues
      </h3>
      <div className="rounded-2xl overflow-hidden bg-red-50 px-4 py-5">
        <ul className="space-y-2">
          {reasons.map((reason, i) => {
            const text = typeof reason === "string"
              ? reason
              : reason?.message || reason?.reason || JSON.stringify(reason);
            return (
              <li key={i} className="flex items-start gap-2 text-red-700">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-red-500 shrink-0" />
                <span className="text-sm">{text}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
